import { Component, input } from '@angular/core';

@Component({
  selector: 'lgb-swipe-hint',
  standalone: false,
  templateUrl: './swipe-hint.html',
  styleUrl: './swipe-hint.css',
})
export class SwipeHint {
  readonly msg=input('Balayez pour voir les autres pages');
}
